import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { checkValidJwt } from "../../utils";
import React from "react";

const NotFound = ({
  url,
  statusCode,
}: {
  url: string | null;
  statusCode: string | null;
}) => {
  const history = useNavigate();
  const dispatch = useDispatch();

  const { background, header } = useSelector((state: any) => state.theme);
  const { jwt } = useSelector((state: any) => state.user);

  React.useEffect(() => {
    if (!checkValidJwt(jwt)) {
      dispatch({ type: "LOGOUT" });
    }
  }, []);

  const handleRedirect = () => {
    if (!checkValidJwt(jwt)) {
      dispatch({ type: "LOGOUT" });
      //@ts-ignore
      history("../login");
      return;
    }
    if (statusCode === "401") {
      dispatch({ type: "LOGOUT" });
      //@ts-ignore
      history.push(url);
    } else {
      history("inicio");
    }
  };

  const data_404 = require("../../data/notfound.json");
  const data_401 = require("../../data/erro401.json");

  return (
    <div
      className={"not-found"}
      style={{
        backgroundColor: background,
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <h3
        style={{
          color: header.textColor,
        }}
      >
        La sesión ha caducado. Vuelve a inciar con tu usuario y contraseña
      </h3>
      <button
        onClick={handleRedirect}
        style={{
          color: header.textColor,
          cursor: "pointer",
          backgroundColor: "transparent",
          border: "none",
          outline: "none",
          fontSize: 28,
          fontWeight: "800",
        }}
      >
        Ir al inicio
      </button>
    </div>
  );
};
export default NotFound;
